import { Account } from '@/domain/usecases'
import { defer } from 'react-router-dom'
import BaseLoader from './base-loader'

export default class SimpleImageLoader extends BaseLoader {
  constructor(
    readonly account: Account.Model,
    private readonly importImageModule: Promise<{ default: string }>
  ) {
    super(account)
  }

  async loader() {
    return defer({
      data: super.decodeImportImage(this.importImageModule)
    })
  }
}
